import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ShellTopBarComponent } from './shell-top-bar/shell-top-bar.component';

@NgModule({
  declarations: [ShellTopBarComponent],
  imports: [CommonModule, MatIconModule],
  exports: [ShellTopBarComponent],
})
export class ShellModule {}
